import React from 'react'
import Header from '../Header/Header'
import NumerosDataOptimized from '../../Components/Admin/NumerosData/NumerosDataOptimized'
import HeaderDash from '../../Components/Admin/HeaderDash/HeaderDash'

export default function Numeros() {
    return (
        <div className='containerGrid'>
            <Header />

            <section className='containerSection'>

                <HeaderDash />
                <div className='container'>
                    <NumerosDataOptimized />

                </div>
            </section>
        </div>
    )
}

